import { createAction } from '/@/store/utils';

export const resetProductSelection = createAction('CATALOG:RESET_PRODUCT_SELECTION');
export const resetProductDetail = createAction('CATALOG:RESET_PRODUCT_DETAIL');
export const setCatalogZone = createAction('CATALOG:SET_ZONE');
export const setCatalogComparisons = createAction('CATALOG:SET_COMPARISONS');
export const setCatalogCropType = createAction('CATALOG:SET_CROP_TYPE');
export const setCatalogProductType = createAction('CATALOG:SET_PRODUCT_TYPE');
export const setTechnology = createAction('CATALOG:SET_TECHNOLOGY');
export const setCatalogSortField = createAction('CATALOG:SET_SORT_FIELD');
export const setCropProtectionTargetSearch = createAction('CATALOG:SET_CROP_PROTECTION_TARGET_SEARCH');
export const clean = createAction('CATALOG:CLEAN');
export const deleteTechnology = createAction('CATALOG:DELETE_TECHNOLOGY');
export const resetProductComparison = createAction('CATALOG:RESET_PRODUCT_COMPARISON');
